/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useEffect, useState } from "react";

import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import breakpoints from "assets/theme/base/breakpoints";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { appConstants } from "utils/appConstants";
import { generateDataList, getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { deletePlanFeatureRecords, deleteSubscriptionPlanRecords, fetchPlanFeatures, fetchPlanNames, fetchSubscriptionPlan } from "utils/superAdminApi";


let planId = "All";

let searchParameter = "";
let planStatus = "All";


function SubscriptionPlan() {

  const defaultHrMarginLeft = 20;
  const [table, setTable] = useState("subscription_plan");
  // eslint-disable-next-line no-unused-vars
  const [hrWidth, setHrWidth] = useState(151);
  // eslint-disable-next-line no-unused-vars
  const [hrMarginLeft, setHrMarginLeft] = useState(defaultHrMarginLeft);
  const [showSubscriptionPlanTable, setShowSubscriptionPlanTable] = useState(true);
  const [showPlanFeatureTable, setShowPlanFeatureTable] = useState(false);
  const [planNames, setPlanNames] = useState([]);
  const [screenName, setScreenName] = useState("Subscription Plans");
  const [customerReload, setCustomerReload] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsPlan, setRowsPlan] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [totalRowsPlan, setTotalRowsPlan] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);

  const [values, setValues] = React.useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    planName: "",
    planID: "All",
    planCode: "",
    planMonthlyCost: "",
    planSequence: "",
    planStatus: "All",
    initialValue: "",
    finalValue: "",
    defaultBusinessSubscriptionPlan: "",
    searchParameter: "",
    searchParameterList: [
      "planName",
      "planCode",
      "planSequence",
      "planStatus",
      "planMonthlyCost",
      "planSequenceString",
      "planMonthlyCostString",
      "subscriptionPlans.planName",
      "standardFeatures.featureName",
      "featureSequenceString",
      "standardFeatures.featureType",
      "featureCountString",
      "selectionBasedValueWithType",
      "fromSlabValue",
      "toSlabValue",
      "slabRateString",
    ],
  });

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchSubscriptionPlanData();
      await fetchPlanFeaturesData();
    })();
  }, [values.planStatus, values.sortingType, perPage, dispatch, values.planID]);

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  useEffect(() => {
    if (values.filterValues.length == "") {
      fetchSubscriptionPlanData();
      fetchPlanFeaturesData();
    }
  }, [values.filterValues]);

  const handleDeleteDialogeClick = async (_id) => {

    values._id = []
    values._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    if (table === "subscription_plan") {
      deleteStandard();
    } else {
      deletePlan();
    }
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchSubscriptionPlanData();
  };

  const handlePageChangePlan = page => {
    values.page = page;
    fetchPlanFeaturesData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handlePerRowsChangePlan = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };


  const deleteStandard = async () => {
    await deleteSubscriptionPlanRecords(values, (data) => {
      fetchSubscriptionPlanData();
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  const deletePlan = async () => {
    await deletePlanFeatureRecords(values, (data) => {
      fetchPlanFeaturesData();
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  async function getRight() {
    let right = await getScreenRight("Subscription Plans")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)
  }

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  useEffect(() => {
    planStatus = values.planStatus;
    changeCustomerReload();
  }, [values.planStatus]);

  const fetchSubscriptionPlanData = async () => {
    values.searchParameter = searchParameter;
    values.planStatus = planStatus;
    await fetchSubscriptionPlan(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  const fetchPlanFeaturesData = async () => {
    values.searchParameter = searchParameter;
    values.planStatus = planStatus;
    values.planID = planId;
    await fetchPlanFeatures(values, (data) => {
      setTotalRowsPlan(data.Result_Output.totalDocs);
      console.log("asdsadsa", data.Result_Output.docs)
      setRowsPlan(data.Result_Output.docs)
    }, dispatch)
  };

  const fetchPlanNamesData = async () => {
    fetchPlanNames(values, async (data) => {
      setPlanNames(await generateDataList(data.Result_Output, "_id", "planName"));
    });
  };

  useEffect(() => {
    planId = values.planID;
    planStatus = values.planStatus;
    changeCustomerReload();
  }, [values.planStatus, values.planID]);



  // //Starts here change the pagination text Rows per page to Record per page
  //  let changePaginationText = document.getElementsByClassName("rdt_Pagination")[0];
  //  if (changePaginationText !== undefined) {
  //    changePaginationText.getElementsByTagName('span')[0].textContent = "Records Per Page";
  //  }



  let columns = [
    {
      name: "Plan Name",
      selector: row => row.planName,
      sortable: true,
      sortField: 'planName',
      left: true,

    },
    {
      name: "Plan Code",
      selector: row => row.planCode,
      sortable: true,
      sortField: 'planCode',
      center: 'true',
    },
    {
      name: "Plan Sequence",
      selector: row => row.planSequence,
      sortable: true,
      sortField: 'planSequence',
      center: 'true',
    },
    {
      name: "Plan Monthly Cost ($)",
      selector: row => row.planMonthlyCost,
      sortable: true,
      sortField: 'planMonthlyCost',
      center: 'true',
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "12px" }}>Status</p>,
      selector: row => row.planStatus,
      sortable: true,
      sortField: 'planStatus',
      center: 'true',
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: 'true',
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/subscriptionPlan/edit/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item >
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>

          </Grid>
        </>
      ),
    },
  ];

  const subscriptionPlanTable = (
    <>
      {showSubscriptionPlanTable && (
        <div >
          <Card color="primary">
            <Grid container display={"flex"} justifyContent="end" mt={1.6} gap={2} >
              <Grid lg={2.5} xs={6} >
                <FormControl fullWidth>
                  <InputLabel id="Status">Filter By Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ height: "44.11px" }}
                    label="Filter By Status"
                    value={values.planStatus}
                    onChange={(e) => setValues({ ...values, planStatus: e.target.value })}

                  >
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={2.5} xs={6}>
                <TextField
                  type="text"
                  variant="outlined"
                  fullWidth
                  className="searchButton"
                  placeholder="Search..."
                  label="Search Filter"
                  value={values.filterValues}
                  onChange={handleSearchFilter}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") fetchSubscriptionPlanData();
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchSubscriptionPlanData}>
                          <GridSearchIcon color="white" />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <div style={{ marginRight: '16px' }}>
                <Link to={"/subscriptionPlan/new"}>
                  <MDButton
                    variant="contained"
                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                    color={disableColor ? "secondary" : "success"}
                    style={{ width: "99px", height: "44.11px" }}
                  >
                    Add New
                  </MDButton>
                </Link>
              </div>
            </Grid>
            <CardContent>
              <BTable
                title={title}
                columns={columns}
                data={rows}
                selectableRows={false}
                sortingType={handleSort}
                sortServer
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}
              />
            </CardContent>
          </Card>
        </div >
      )}
    </>
  );

  let columnsPlanFeatures = [
    {
      name: "Plan Name",
      selector: row => row.subscriptionPlans.planName,
      sortable: true,
      sortField: 'subscriptionPlans.planName',
      // style: { paddingLeft: "10px" }
    },
    {
      // name: "Feature Name",
      name: <p style={{ paddingLeft: "12px" }}>Feature Name</p>,
      selector: row => row.standardFeatures.featureName,
      sortable: true,
      sortField: 'standardFeatures.featureName',
      center: 'true',
    },
    {
      name: <p style={{ paddingLeft: "40px" }}>Feature Sequence</p>,
      selector: row => row.featureSequence,
      sortable: true,
      sortField: 'featureSequence',
      center: 'true',
    },
    {
      // name: "Feature Type",
      name: <p style={{ paddingLeft: "12px" }}>Feature Type</p>,
      selector: row => row.standardFeatures.featureType,
      sortable: true,
      sortField: 'standardFeatures.featureType',
      center: 'true',
    },
    {
      // name: "Feature Type",
      name: <p style={{ paddingLeft: "12px" }}>Selection Based</p>,
      selector: row => row.featureCountWithType.selectionBasedValue,
      sortable: true,
      sortField: 'standardFeatures.featureType',
      center: 'true',
    },
    {
      // name: "Feature Count",
      name: <p style={{ paddingLeft: "12px" }}>Feature Count</p>,
      selector: (row) => row.featureCountWithType.featureCount,
      sortable: true,
      sortField: 'featureCountWithType.featureCount',
      center: 'true',
      Cell: ({ row }) => (
        <>
          {row.featureCountWithType.featureType === "Count Based" ? row.featureCountWithType.featureCount : ""}
        </>
      ),
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: 'true',
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/subscriptionPlan/editPlanFeatures/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item >
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>

          </Grid>
        </>
      ),
    },
  ];

  const planFeatureTable = (
    <>
      {showPlanFeatureTable && (
        <>
          <div>
            <Card color="primary">
              {/* <PageTitle screenName="Standard Features" /> */}
              <Grid container display={"flex"} justifyContent="end" mt={1.6} gap={2} px={2.2}>
                <Grid lg={2.5} xs={6} >
                  <FormControl fullWidth>
                    <InputLabel id="Status" >Plan Name</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      style={{ height: "44.11px" }}
                      label="Plan Name"
                      onChange={(e) => setValues({ ...values, ["planID"]: e.target.value })}
                      value={values.planID}
                      variant="outlined"
                      autoFocus={true}
                    >
                      <MenuItem value={"All"}>Select Plan Name</MenuItem>
                      {planNames}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid lg={2.5} xs={6}>
                  <TextField
                    type="text"
                    variant="outlined"
                    fullWidth
                    className="searchButton"
                    placeholder="Search..."
                    label="Search Filter"
                    value={values.filterValues}
                    onChange={handleSearchFilter}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") fetchPlanFeaturesData();
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchPlanFeaturesData}>
                            <GridSearchIcon color="white" />
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <div style={{ paddingLeft: '16px' }}>
                  <Link to={"/subscriptionPlan/addPlanFeatures"}>
                    <MDButton
                      variant="contained"
                      className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                      color={disableColor ? "secondary" : "success"}
                      style={{ width: "99px", height: "44.11px" }}
                    >
                      Add New
                    </MDButton>
                  </Link>
                </div>
              </Grid>
              <CardContent>
                <BTable
                  title={title}
                  columns={columnsPlanFeatures}
                  data={rowsPlan}
                  selectableRows={false}
                  // onSort={handleSort}
                  sortingType={handleSort}
                  sortServer
                  pagination
                  paginationServer
                  paginationTotalRows={totalRowsPlan}
                  onChangeRowsPerPage={handlePerRowsChangePlan}
                  onChangePage={handlePageChangePlan}

                  fixedHeaderScrollHeight="410px"
                  fixedHeader={true}
                />
              </CardContent>
            </Card>
          </div >
        </>
      )}
    </>
  );

  useEffect(() => {
    getRight();
    if (
      sessionStorage.getItem("SUBSCRIPTION_PLANS_STORAGE") !== undefined &&
      sessionStorage.getItem("SUBSCRIPTION_PLANS_STORAGE") !== null
    ) {
      setTable(sessionStorage.getItem("SUBSCRIPTION_PLANS_STORAGE"));
      sessionStorage.removeItem("SUBSCRIPTION_PLANS_STORAGE");
    }
  }, []);

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === 'subscription_plan') {
      setTable('subscription_plan');
    }
    else if (sessionStorage.getItem("PARA_TABLE") === 'plan_feature') {
      setTable('plan_feature');
    }
    if (table === "subscription_plan") {
      setScreenName("Subscription Plans")
      values.planStatus = "All";
      // values.planStatus = "Active";
      setShowSubscriptionPlanTable(true);
      setShowPlanFeatureTable(false);
      setHrWidth(163);
      setHrMarginLeft(defaultHrMarginLeft);
      setTabValue(0)
    }
    else if (table === "plan_feature") {
      setScreenName("Plan Features")
      planId = "All";
      fetchPlanNamesData();
      setShowSubscriptionPlanTable(false);
      setShowPlanFeatureTable(true);
      setHrWidth(135);
      setHrMarginLeft(229);
      setTabValue(1)
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);


  const renderTable = () => {
    return (
      <>
        {subscriptionPlanTable}
        {planFeatureTable}
      </>
    );
  };
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);

  const data = document.getElementsByClassName('MuiTabs-root').border = "1px solid red";
  console.log(data)

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName={screenName} />
          <Grid container display={"flex"} px={2.2} mt={2}>
            <Grid item lg={6}>
              <Tabs
                className="tab-container"
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}

                sx={{
                  // "& .Mui-selected": { color: "#fff !important" },
                  "& .Mui-selected": { color: "#fff !important", background: `${barColor} !important`, },
                  '.MuiTabs-indicator': { background: `${barColor} !important` },


                }}
              >
                <Tab
                  onClick={() => setTable("subscription_plan")}
                  label="Subscription Plans"

                />
                <Tab
                  onClick={() => setTable("plan_feature")}
                  label="Plan Features"
                />
              </Tabs>
            </Grid>
          </Grid>
          {renderTable()}
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}

      />
    </DashboardLayout>
  );
}

export default SubscriptionPlan;
